import {defineMessages, useIntl} from 'react-intl';
import {customers} from '@sail/icons/react/Icon';
import {Action, Icon, view} from '@sail/ui';
import {Divider} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';

const messages = defineMessages({
  contactSupportAgent: {
    id: 'conversations_ui.conversation.escapeHatchButton.contactSupportAgent',
    description:
      'Label for the button that escalates the chat to a human support agent',
    defaultMessage: 'Contact support agent',
  },
});

export const EscapeHatchButton = ({
  onPress,
  disabled = false,
}: {
  onPress: () => void;
  disabled?: boolean;
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const isLinkAudience = theme.audience === 'link';

  return (
    <>
      <Divider />
      <Action
        data-testid="escape-hatch-button"
        onPress={onPress}
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: 'xsmall',
          paddingY: 12,
          paddingX: 16,
          width: '100%',
          borderRadius: 'none',
          color: isLinkAudience ? theme.primaryActionColor : 'action.primary',
          ':hover': {
            backgroundColor: isLinkAudience
              ? theme.secondaryButtonBackground ?? 'offset'
              : 'offset',
          },
          '[aria-disabled="true"]': {
            color: 'action.primary.disabled',
            cursor: 'not-allowed',
          },
          '[aria-disabled="true"]:hover': {
            backgroundColor: 'transparent',
          },
        }}
        disabled={disabled}
      >
        <Icon icon={customers} size="xsmall" />
        <view.span css={{fontSize: '12px', lineHeight: '16px'}}>
          {intl.formatMessage(messages.contactSupportAgent)}
        </view.span>
      </Action>
    </>
  );
};
